// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TGetPopularCitiesForGeopopupModel,
  IMappers,
  TGetPopularCitiesForGeopopupResponse,
  IGetPopularCitiesForGeopopupResponse,
  IGetPopularCitiesForGeopopupResponseError,
} from './types';

export const defaultConfig: TGetPopularCitiesForGeopopupModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'geo-suggest',
  pathApi: '/v1/get-popular-cities-for-geopopup/',
  responseType: 'json',
} as TGetPopularCitiesForGeopopupModel;

export function createGetPopularCitiesForGeopopupModel(): TGetPopularCitiesForGeopopupModel {
  return {
    ...defaultConfig,
  };
}

export interface IGetPopularCitiesForGeopopupOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetPopularCitiesForGeopopup<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetPopularCitiesForGeopopupOptions<TResponse200, TResponse400>): Promise<
  TGetPopularCitiesForGeopopupResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetPopularCitiesForGeopopupModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetPopularCitiesForGeopopupResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetPopularCitiesForGeopopupResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetPopularCitiesForGeopopupResponse;
}
